import React, { useEffect, useState } from 'react';
import { ShieldCheck, Mail } from 'lucide-react';
import { fetchAdminIdentity } from '../../lib/api';

/**
 * Top banner above the admin tabs. Surfaces the Master Administrator
 * identity (seva@shreesavaa.com) and the brand correspondence address.
 */
const MasterAdminBanner = () => {
  const [identity, setIdentity] = useState(null);
  useEffect(() => {
    fetchAdminIdentity().then(setIdentity).catch(() => setIdentity(null));
  }, []);

  if (!identity) {
    return (
      <div
        data-testid="admin-identity-loading"
        className="h-24 bg-[#C1D7E2]/40 animate-pulse"
      />
    );
  }

  return (
    <div
      data-testid="admin-identity-banner"
      className="border border-[#7C9CB1] bg-gradient-to-r from-[#C1D7E2]/50 to-[#AAC6D4]/30 px-6 md:px-8 py-5 md:py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
    >
      <div className="flex items-start gap-4">
        <ShieldCheck size={22} strokeWidth={1.2} className="text-[#7C9CB1] mt-1" />
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#90B0BF] mb-1">
            {identity.master_admin_title}
          </p>
          <a
            href={`mailto:${identity.master_admin_email}`}
            data-testid="admin-master-email"
            className="font-serif text-2xl md:text-3xl text-[#7C9CB1] hover:text-[#90B0BF] transition-colors"
          >
            {identity.master_admin_email}
          </a>
          <p className="mt-1 font-mono text-[10px] tracking-[0.2em] uppercase text-[#90B0BF]">
            {identity.circle}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 text-[#7C9CB1] border-t md:border-t-0 md:border-l border-[#7C9CB1]/40 pt-4 md:pt-0 md:pl-6">
        <Mail size={16} strokeWidth={1.2} />
        <span className="font-mono text-xs tracking-wide">
          Brand correspondence routed to{' '}
          <span data-testid="admin-brand-email" className="font-medium">
            {identity.brand_email}
          </span>
        </span>
      </div>
    </div>
  );
};

export default MasterAdminBanner;
